import React, { FC, useEffect, useState } from 'react';
import {
  Button,
  CssBaseline,
  Paper,
  makeStyles,
  CircularProgress,
  Theme,
} from '@material-ui/core';
import { toast } from 'react-toastify';
import { useAuth0 } from '@auth0/auth0-react';

const useStyles = makeStyles((theme: Theme) => ({
  layout: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #F8F8F9 0%, #FFF5F0 100%)',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(5, 5, 4),
    borderRadius: 16,
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
    maxWidth: 380,
    width: '100%',
  },
  logo: {
    width: 72,
    height: 72,
    marginBottom: theme.spacing(2),
  },
  brandName: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#1a1a1a',
    marginBottom: theme.spacing(4),
    letterSpacing: '-0.01em',
  },
  submit: {
    marginTop: theme.spacing(1),
    height: 44,
    borderRadius: 8,
    fontSize: '0.95rem',
    fontWeight: 600,
    textTransform: 'none',
    color: '#fff !important',
    backgroundColor: '#df6d2e !important',
    boxShadow: '0 2px 8px rgba(223, 109, 46, 0.3)',
    '&:hover': {
      backgroundColor: '#c45a1f !important',
    },
  },
}));

const LoginPage: FC = () => {
  const classes = useStyles();
  const { loginWithRedirect } = useAuth0();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    localStorage.setItem('redirectAfterLogin', window.location.pathname);
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    loginWithRedirect().catch(() => {
      setLoading(false);
      toast.error('Login failed, please try again.');
    });
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <main className={classes.layout}>
        <Paper className={classes.paper}>
          <img
            alt="COMET Signals"
            className={classes.logo}
            src="images/logos/logomark.png"
          />
          <div className={classes.brandName}>COMET Signals</div>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              'Sign in'
            )}
          </Button>
        </Paper>
      </main>
    </React.Fragment>
  );
};

export default LoginPage;
